module.exports = __webpack_public_path__ + "media/images/pc/stores/fukuoka/fukuoka_sns_03-3ebdce3d661a12b2e771e9bf72af870a.jpg";